import { render, staticRenderFns } from "./measurements-modal.vue?vue&type=template&id=49f8b096&"
import script from "./measurements-modal.vue?vue&type=script&lang=js&"
export * from "./measurements-modal.vue?vue&type=script&lang=js&"
import style0 from "./measurements-modal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports